





















import { computed, defineComponent, PropType } from '@vue/composition-api';
import parse from 'date-fns/esm/parse';
import { Language } from '@front-app/services/UserApi/UserModel';
import ProfileCard from '../ProfileCard.vue';
import { EditableSection } from '../editableProfileSections';

export default defineComponent({
	components: { ProfileCard },
	props: {
		isCurrentUserProfile: Boolean,
		gender: {
			type: String,
			required: false,
			default: '',
		},
		birthYear: {
			type: String,
			required: false,
			default: '',
		},
		birthMonth: {
			type: String,
			required: false,
			default: '',
		},
		birthDay: {
			type: String,
			required: false,
			default: '',
		},
		languages: {
			type: Array as PropType<Language[]>,
			required: true,
		},
	},
	setup(props, ctx) {
		const birthday = computed(() => {
			const { birthYear, birthMonth, birthDay } = props;
			const parseableString = `${birthYear || 1982}-${birthMonth || 'Jan'}-${birthDay || 1}`;
			const parsedDate = parse(parseableString, 'y-MMM-d', new Date(0, 0, 0, 0, 0, 0, 0));
			const format = getBirthdayFormat(birthYear, birthMonth, birthDay);
			try {
				return format ? ctx.root.$d(parsedDate, format) : '';
			} catch (e) {
				return '';
			}
		});
		return {
			birthday,
			EditableSection,
		};
	},
});

function getBirthdayFormat(birthYear: string, birthMonth: string, birthDay: string): string {
	if (birthYear && birthMonth && birthDay) {
		return 'short';
	}
	if (birthYear && birthMonth) {
		return 'yearAndMonth';
	}
	if (birthDay && birthMonth) {
		return 'dayAndMonth';
	}
	if (birthYear) {
		return 'year';
	}
	if (birthMonth) {
		return 'month';
	}
	return '';
}
